import { OrderMarketTypeEnum } from '../../enum/orders/market-type.enum';
import { SecurityCategory } from '../../enum/security-category.enum';
import { IStressResponse } from '../../interfaces/pos-risk/stress.interface';
import { InstrumentLite } from './instrument-lite.model';
import { LogoInstrument } from './logo-instrument.model';

export class Instrument {

    public brieflyDescribeStock: string;
    public classificationName: string;
    public code: string;
    public codeBase: string;
    public codeRepresentTypeOfPriceInstrument: string;
    public contractMultiplier: number;
    public currencyExercisePriceOption: string;
    public currencyUsedPrice: string;
    public dateLastModification: string;
    public dateOfBid: string;
    public descriptionStock: string;
    public exercisePriceOption: string;
    public expirationDateMarketOption: string;
    public formQuote: string;
    public indicatesGroupStockBelongs: string;
    public logo: LogoInstrument;
    public marketCode: number;
    public monthYearMaturity: string;
    public optionType: string;
    public productAssociatedInstrument: string;
    public putOrCall: string;
    public qtdDaysToMaturity: number;
    public qtdDaysUsefulToMaturity: number;
    public quoteFactor: number;
    public rangeMinimumPriceIncrements: string;
    public securityId: string;
    public securitySubType: string;
    public securityType: string;
    public typeMarket: OrderMarketTypeEnum;
    public typeMarketDescription: string;
    public standardLot: number;
    public tickSize: number;
    public typeStockCode: string;
    public uniqueIdentificationInstrument: string;
    public rank: number;
    public rankDescription: string;
    public priceLastTrade: number;
    public closingPricePreviousDay: number;
    public openingPrice: number;
    public stress: IStressResponse;
    public variation: number;
    public dateTimeLastTrade: string;
    public securityCategory: SecurityCategory;
    public brokerageFactor: number;
    public blockedQuantity: number;

    constructor(response = {}) {
        Object.keys(response).forEach((key) => {
            this[key] = response[key];
        });
    }

    /** Preenche os dados a partir de um instrument lite
     * @param instrument instrumento a ser usado
     */
    public fromInstrumentLite(instrument: InstrumentLite) {
        this.brokerageFactor = instrument.brokerageFactor;
        this.code = instrument.active;
        this.descriptionStock = instrument.description;
        this.logo = new LogoInstrument();
        this.logo.content = instrument.logoPath;
        this.quoteFactor = instrument.quoteFactor;
        this.standardLot = instrument.standardLot;
        this.stress = instrument.stress;
        this.typeMarket = instrument.typeMarket;
        this.priceLastTrade = instrument.unitPrice;
        this.variation = instrument.variation;
        this.rangeMinimumPriceIncrements = instrument.rangeMinimumPriceIncrements.toString();
        this.securityCategory = instrument.securityCategory;
    }

    public toInstrumentLite(): InstrumentLite {
        const response: InstrumentLite = {
            active: this.code,
            brokerageFactor: this.brokerageFactor,
            dateTimeLastTrade: this.dateTimeLastTrade,
            description: this.descriptionStock,
            logoPath: this.logo!.content,
            quoteFactor: this.quoteFactor,
            rangeMinimumPriceIncrements: +this.rangeMinimumPriceIncrements,
            securityCategory: this.securityCategory,
            standardLot: this.standardLot,
            stress: this.stress,
            typeMarket: this.typeMarket,
            unitPrice: this.priceLastTrade || this.openingPrice || this.closingPricePreviousDay,
            variation: this.variation,
        };

        return new InstrumentLite(response);
    }

}
